import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {CustomerTraderService} from "../../../services/customer/customer-trader.service";
//import {Trader} from "/src/app/model/customer/Trader";
import {Trader} from "../../../model/customer/trader";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-trader',
  templateUrl: './trader.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class TraderComponent extends CrudBaseComponent<Trader> {

  constructor(cdref: ChangeDetectorRef,
              customerTradeService: CustomerTraderService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerTradeService;
    this.newRecord = new Trader();
    this.prepareForEdit = this.prepareRecordForEdit;
    this.prepareForClone = this.prepareRecordForClone;
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'code',
        width: 200,
      },
      {
        field: 'initials',
        width: 80,
      },
      {
        field: 'description',
      },
    ];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'code',
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'initials',
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'description',
            column: 4,
            type: TYPE.TEXT
          },]
      },
    ];
  }

  prepareRecordForEdit(): void {
    if (this.formRecord) {
      this.formRecord.originCode = this.formRecord.code;
    }
  }

  prepareRecordForClone(): void {
    if (this.formRecord) {
      this.formRecord.originCode = '';
    }
  }
}
